import { render } from "./App.vue?vue&type=template&id=8319f1b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8319f1b0&lang=css"
script.render = render

export default script